const GET_ASSET_ITEM_STATUS_HEADER_DETAIL = 'GET_ASSET_ITEM_STATUS_HEADER_DETAIL'
const SET_ASSET_ITEM_STATUS_HEADER_DETAIL = 'SET_ASSET_ITEM_STATUS_HEADER_DETAIL'

export {
    GET_ASSET_ITEM_STATUS_HEADER_DETAIL,
    SET_ASSET_ITEM_STATUS_HEADER_DETAIL
}
